/**
 * TaskApiClient -- HTTP client for /api/v1/Tasks.
 *
 * @module infrastructure/api/TaskApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/Tasks';

export const TaskApiClient = {
  // `assignee` filtra por assigned_to exacto (PostgresTaskRepository: "assigned_to = @Assignee"; PROYECTOS-ALINEADOS-T1).
  async list(page = 1, pageSize = 20, status = '', assignee = '') {
    const qs = (status ? `&status=${encodeURIComponent(status)}` : '') + (assignee ? `&assignee=${encodeURIComponent(assignee)}` : '');
    return ApiBase.get(`${BASE}?page=${page}&pageSize=${pageSize}${qs}`);
  },

  async getById(id) {
    return ApiBase.get(`${BASE}/${id}`);
  },

  async create(task) {
    return ApiBase.post(BASE, task);
  },

  async update(id, task) {
    return ApiBase.put(`${BASE}/${id}`, task);
  },

  async updateStatus(id, status) {
    return ApiBase.post(`${BASE}/${id}/status`, { status });
  },

  async remove(id) {
    return ApiBase.del(`${BASE}/${id}`);
  },

  async statistics() {
    return ApiBase.get(`${BASE}/statistics`);
  }
};
